/**
 * Raised when the project row was written but its founding membership was not.
 *
 * The two writes are separate GraphQL mutations and cannot be made atomic from
 * the client. A project without any member is invisible in a solo workspace,
 * where the project list is driven by memberships, so the caller must be able
 * to resume on the same project id instead of creating a twin on retry.
 */
export class ProjectMembershipCreationError extends Error {
  readonly projectId: string

  constructor(projectId: string, options?: { cause?: unknown }) {
    super('project was created but its founding membership was not', options)
    this.name = 'ProjectMembershipCreationError'
    this.projectId = projectId
  }
}

export function isProjectMembershipCreationError(
  error: unknown,
): error is ProjectMembershipCreationError {
  return error instanceof ProjectMembershipCreationError
}
